import { ref } from "vue";
import type { ContainersResponse, InventoryEntry } from "@idle-rpg/shared";
import { apiListContainers } from "../../../api/client";
import { useSessionStore } from "../../../store/session";

const state = ref<ContainersResponse | null>(null);
const loading = ref(false);
const error = ref<string | null>(null);

export function useContainersState() {
  const session = useSessionStore();

  async function refresh(options?: { force?: boolean }) {
    if (!session.token || !session.character) return;
    if (state.value && !options?.force) return;
    loading.value = true;
    error.value = null;
    const res = await apiListContainers(session.token, session.character.id);
    loading.value = false;
    if (!res.ok || !res.data) {
      error.value = "error" in res ? res.error?.message || "Failed to load containers" : "Failed to load containers";
      return;
    }
    apply(res.data as ContainersResponse);
  }

  function apply(next: ContainersResponse) {
    state.value = next;
    if (session.character) {
      session.character.inventory = next.inventory as InventoryEntry[];
      session.character.equipment = next.equipment;
      session.character.carry = next.carry as any;
    }
  }

  function clear() {
    state.value = null;
    loading.value = false;
    error.value = null;
  }

  return { state, loading, error, refresh, apply, clear };
}

